export const normalizeFissionTargetAmount = (value?: number) => {
  const targetAmount = Number(value);
  return Number.isFinite(targetAmount) && targetAmount > 0
    ? targetAmount
    : undefined;
};

export const isFissionTargetReached = (
  currentAmount: number,
  targetAmount?: number,
) => {
  const current = Number(currentAmount);
  const target = normalizeFissionTargetAmount(targetAmount);
  return Number.isFinite(current) && target != null && current >= target;
};
